<template>
    <div class="mt-5 row text-center">
        <div class="col-md-12">
            <h2>{{ cleanUserName }}</h2>
            <hr>
        </div>
        <div class="col-sm-4 col-md-3 pr-0">
            <b-nav v-if="user"
                   fill
                   tabs
                   vertical
            >
                <b-nav-item
                    v-for="(tab, tabIdx) in userTabs"
                    :key="tabIdx"
                    tag="li"
                    :to="tab.route"
                    exact-active-class="active"
                    class="text-sm-left"
                >
                    <template v-if="tab.icons">
                        <fa-icon
                            v-for="(icon, iconIdx) in tab.icons"
                            :key="iconIdx"
                            class=""
                            :icon="icon"
                        />
                    </template>
                    <template v-else>
                        <fa-icon class="fa-fw" :icon="tab.icon" />
                    </template>
                    {{ tab.name }}
                </b-nav-item>
            </b-nav>
        </div>
        <div class="col-sm-8 col-md-9">
            <transition name="fade" mode="out-in">
                <router-view :key="$route.fullPath" />
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    loading: false,

    name: 'User',

    props: {
        userId: { type: Number, required: true },
    },

    data() {
        return {
            user: {
                fname: null
            },
            userTabs: [
                {
                    icon: 'user',
                    name: 'Profile',
                    route: {
                        name: 'admin.users.Profile',
                        params: { userId: this.userId },
                    },
                },
                {
                    icons: ['user-tie', 'user-graduate'],
                    name: 'Roles',
                    route: {
                        name: 'admin.users.Personae',
                        params: { userId: this.userId },
                    },
                },
                {
                    icon: 'user-lock',
                    name: 'Password',
                    route: {
                        name: 'admin.users.Password',
                        params: { userId: this.userId },
                    },
                },
                {
                    icon: 'power-off',
                    name: 'Active Status',
                    route: {
                        name: 'admin.users.Status',
                        params: { userId: this.userId },
                    },
                },
            ],
        };
    },

    computed: {
        cleanUserName() {
            let fname = 'User';
            let lname = 'Name';

            if (this.user.fname) {
                fname = `${this.user.fname.slice(0, 1)}${this.user.fname.toLowerCase().slice(1)}`;
                lname = `${this.user.lname.slice(0, 1)}${this.user.lname.toLowerCase().slice(1)}`;
            }

            return `${fname} ${lname}`;
        },
    },

    watch: {
        userId() {
            this.fetchUserInfo();
        },
    },

    async created() {
        await this.fetchUserInfo();
    },

    methods: {
        async fetchUserInfo() {
            this.user = await this.$store.dispatch('auth/getUserInfo', this.userId);
        },
    },
};
</script>

<style>
.admin-card .card-body {
    padding: 0;
}

.nav-tabs.flex-column .nav-link {
    border-right-color: rgb(222, 226, 230);
}

.nav-tabs.flex-column .nav-link.active {
    border-top-color: rgb(222, 226, 230);
    border-bottom-color: rgb(222, 226, 230);
    border-right-color: rgb(247, 249, 251);
    border-left-color: rgb(222, 226, 230);
}
</style>
